import * as Yup from 'yup';

export const emailSchema = Yup.string()
  .trim()
  .email('Invalid email address')
  .matches(
    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    'Invalid email address'
  )
  .required('Email');
